'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M16 384c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80s-35.8-80-80-80c-3.8 0-7.6 .3-11.3 .8-2.8 .4-5.6-.7-7.3-2.9s-2.3-5.1-1.3-7.8c2.5-6.9 3.9-14.3 3.9-22.1 0-35.3-28.7-64-64-64-23.7 0-44.4 12.9-55.5 32-1.6 2.7-4.5 4.2-7.6 4s-5.8-2.3-6.8-5.2c-13.5-36.7-48.8-62.8-90.1-62.8-53 0-96 43-96 96 0 8.4 1.1 16.6 3.1 24.4 .5 2.1 .2 4.3-.9 6.1s-2.9 3.2-5 3.7C42.1 314.6 16 346.3 16 384zM281.9 152.1c1 .9 1.9 1.7 2.9 2.6 15.7-6.9 33-10.7 51.2-10.7 24.8 0 48 7.1 67.7 19.3 40.8-32.1 92.3-51.3 148.3-51.3l16 0c4.3 0 7.9 3.5 8 8.1l0-112c-.1 4.4-3.7 7.9-8 7.9l-16 0C441.3 16 343.1 69.5 281.9 152.1zm135.3 21c22.5 18.5 38.6 44.6 44.4 74.3 3.7 1.2 7.4 2.6 11 4.2 21.8-17.3 49.4-27.6 79.4-27.6l16 0c4.3 0 7.9 3.5 8 8l0-111.9c-.1 4.4-3.7 7.9-8 7.9l-16 0c-50.5 0-97.1 16.7-134.8 45.1z', 'M281.9 152.1C343.1 69.5 441.3 16 552 16l16 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L552 0c-115.7 0-218.4 55.9-282.6 142.1 4.3 3.1 8.5 6.5 12.5 10zM488.6 259.6c18-12.4 39.8-19.6 63.4-19.6l16 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-16 0c-30 0-57.5 10.3-79.4 27.6 5.5 2.4 10.9 5.1 16 8.1zm-71.4-86.6C454.7 144.8 501.4 128 552 128l16 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-16 0c-56 0-107.5 19.2-148.3 51.3 4.7 3 9.3 6.2 13.6 9.7zM176 160c-61.9 0-112 50.1-112 112 0 7.1 .7 14.1 1.9 20.8-38.3 12.6-65.9 48.7-65.9 91.2 0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0 1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60zM80 272c0-53 43-96 96-96 41.3 0 76.6 26.1 90.1 62.8 1.1 2.9 3.7 4.9 6.8 5.2s6.1-1.3 7.6-4c11.1-19.2 31.8-32 55.5-32 35.3 0 64 28.7 64 64 0 7.8-1.4 15.2-3.9 22.1-1 2.6-.5 5.6 1.3 7.8s4.6 3.3 7.3 2.9c3.7-.5 7.5-.8 11.3-.8 44.2 0 80 35.8 80 80s-35.8 80-80 80L96 464c-44.2 0-80-35.8-80-80 0-37.7 26.1-69.4 61.3-77.8 2.1-.5 3.9-1.8 5-3.7s1.4-4.1 .9-6.1c-2-7.8-3.1-16-3.1-24.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;